export enum ProfileType {
    IFA = 'Ifa',
    BORROWER = 'Borrower',
    LENDER = 'Lender'
}
